// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomX = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_1856_49773)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9.65934 12.3406L2.6665 3.44434H8.20533L12.522 8.94284L17.1336 3.46909H20.1841L13.9969 10.8216L21.3332 20.1666H15.8109L11.1369 14.2203L6.14687 20.1501H3.07985L9.65934 12.3406ZM16.6158 18.5182L6.06272 5.09266H7.39979L17.9396 18.5182H16.6158Z',
        fill: 'currentColor',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_1856_49773',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '18.6667',
          height: '18.6667',
          fill: 'white',
          transform: 'translate(2.6665 2.66699)',
        }),
      ),
    ),
  );

export { IconCustomX };
